import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../../components/common/Card/Card';
import Table from '../../components/common/Table/Table';
import LoadingSpinner from '../../components/common/LoadingSpinner/LoadingSpinner';
import StatusBadge from '../../components/common/StatusBadge/StatusBadge';
import { getMyCounsellorProjects } from '../../services/counsellorService';
import { formatDate } from '../../utils/helpers';
import styles from './CounsellorProjects.module.css';

const CounsellorProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const data = await getMyCounsellorProjects();
      setProjects(data);
    } catch (error) {
      console.error('Error fetching projects:', error);
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      header: 'Project Name',
      accessor: 'project_name',
      cell: (row) => (
        <span className={styles.projectName}>{row.project_name}</span>
      )
    },
    {
      header: 'Track',
      accessor: 'project_track',
      cell: (row) => (
        <span className={styles.track}>
          {row.project_track?.replace(/_/g, ' ').toUpperCase()}
        </span>
      )
    },
    {
      header: 'Status',
      accessor: 'status',
      cell: (row) => <StatusBadge status={row.status} />
    },
    {
      header: 'Start Date',
      accessor: 'start_date',
      cell: (row) => formatDate(row.start_date)
    },
    {
      header: 'End Date',
      accessor: 'end_date',
      cell: (row) => row.end_date ? formatDate(row.end_date) : '-'
    },
    {
      header: 'Actions',
      accessor: 'actions',
      cell: (row) => (
        <button
          className={styles.viewBtn}
          onClick={() => navigate(`/counsellor/projects/${row.id}`)}
        >
          View Details
        </button>
      )
    }
  ];

  if (loading) {
    return (
      <div className={styles.loading}>
        <LoadingSpinner size="large" message="Loading projects..." />
      </div>
    );
  }

  const activeProjects = projects.filter(p => p.status === 'in_progress').length;
  const completedProjects = projects.filter(p => p.status === 'completed').length;

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1 className={styles.title}>My Projects</h1>
      </div>

      <div className={styles.statsRow}>
        <Card className={styles.statCard}>
          <div className={styles.statContent}>
            <span className={styles.statValue}>{projects.length}</span>
            <span className={styles.statLabel}>Total Projects</span>
          </div>
        </Card>
        <Card className={styles.statCard}>
          <div className={styles.statContent}>
            <span className={styles.statValue}>{activeProjects}</span>
            <span className={styles.statLabel}>Active Projects</span>
          </div>
        </Card>
        <Card className={styles.statCard}>
          <div className={styles.statContent}>
            <span className={styles.statValue}>{completedProjects}</span>
            <span className={styles.statLabel}>Completed Projects</span>
          </div>
        </Card>
      </div>

      <Card>
        {projects.length === 0 ? (
          <div className={styles.empty}>
            <p>No projects assigned yet</p>
          </div>
        ) : (
          <Table columns={columns} data={projects} />
        )}
      </Card>
    </div>
  );
};

export default CounsellorProjects;

